import {inject, Injectable} from '@angular/core';
import {ColDef} from "ag-grid-community";
import {DatePipe} from "@angular/common";

@Injectable({
  providedIn: 'root'
})
export class FailedRefundTables {

  private datePipe = inject(DatePipe);

  public failedRefundColDefs: ColDef[] = [
    {
      headerName: 'Player ID',
      field: 'PlayerId',
      width: 250,
      resizable: true,
      sortable: true
    },
    {
      headerName: 'Stripe Charge ID',
      field: 'StripeChargeId',
      width: 200,
      resizable: true,
      sortable: true
    },
    {
      headerName: 'Refund Amount',
      field: 'RefundAmount',
      width: 150,
      resizable: true,
      sortable: true,
      valueFormatter: (params) => {
        const amount = params.value / 100;
        return `$${amount.toFixed(2)}`;
      }
    },
    {
      headerName: 'Attempted On',
      field: 'RefundAttemptedOn',
      width: 180,
      resizable: true,
      sortable: true,
      valueFormatter: (params) => {
        const convertedDate = this.datePipe.transform(params.value, 'MMM d, y hh:mm a', 'UTC');
        return convertedDate ? convertedDate : '';
      }
    },
    {
      headerName: 'Description',
      field: 'Description',
      width: 300,
      resizable: true,
      sortable: true,
      valueFormatter: (params) => {
        const description = params.value || '';
        return description.length > 60 ? description.substring(0, 60) + '...' : description;
      }
    },
    {
      headerName: 'Stripe Error',
      field: 'StripeError',
      width: 300,
      resizable: true,
      sortable: true,
      valueFormatter: (params) => {
        const error = params.value || '';
        return error.length > 60 ? error.substring(0, 60) + '...' : error;
      }
    }
  ];
}
